import React from "react";
import { Helmet } from 'react-helmet-async';
import '../Styles/ins_20.css';

function BlogPage() {

  const pageUrl = encodeURIComponent('https://outstandingworkplaces.co/gcc');
  const shareText = encodeURIComponent('From Cost Centre to Capability Centre: The New Era of GCCs!');

  const handleTwitterShare = () => {
    window.open(`https://twitter.com/intent/tweet?url=${pageUrl}&text=${shareText}`, '_blank', 'width=600,height=500');
  };

  const handleLinkedInShare = () => {
    window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${pageUrl}`, '_blank', 'width=600,height=500');
  };

  const handleFacebookShare = () => {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${pageUrl}`, '_blank', 'width=600,height=500');
  };

  const handleWhatsAppShare = () => {
    window.open(`https://wa.me/?text=${shareText}%20${pageUrl}`, '_blank');
  };

  return (
    <>
      <Helmet>
        <title>The New Era of GCCs — Outstanding Workplaces</title>
        <meta property="og:title" content="The New Era of GCCs — Outstanding Workplaces" />
        <meta property="og:description" content="From Cost Centre to Capability Centre: The New Era of GCCs" />
        <meta property="og:image" content="https://res.cloudinary.com/daflhizdn/image/upload/v1778052541/i_18_hueuhz.jpg" />
        <meta property="og:url" content="https://outstandingworkplaces.co/gcc" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="The New Era of GCCs — Outstanding Workplaces" />
        <meta name="twitter:description" content="From Cost Centre to Capability Centre: The New Era of GCCs" />
        <meta name="twitter:image" content="https://res.cloudinary.com/daflhizdn/image/upload/v1778052541/i_18_hueuhz.jpg" />
      </Helmet>

       <div className="sight_20_page_wrapper">
        <div className="sight_20_content_container">

          <div className="sight_20_section_one">

            <h1 className="sight_20_page_title">
             From Cost Centre to Capability Centre: The New Era of GCCs
            </h1>

            <div className="sight_20_row">

              <div className="sight_20_left">
                <div className="sight_20_image_wrapper">
                  <img src="/gc.png" alt="Team meeting discussion" className="sight_20_blog_image" />
                </div>

                {/* SHARE SECTION */}
                <div className="sight_20_share_section">
                  <span className="sight_20_share_text">Share :</span>
                  <div className="sight_20_social_icons">

                    <img
                      src="/assets/Twitter_1.png"
                      className="sight_20_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleTwitterShare}
                      alt="Share on Twitter"
                    />

                    <img
                      src="/assets/LinkedIn_1.png"
                      className="sight_20_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleLinkedInShare}
                      alt="Share on LinkedIn"
                    />

                    <img
                      src="/assets/Facebook_1.png"
                      className="sight_20_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleFacebookShare}
                      alt="Share on Facebook"
                    />

                    <img
                      src="/assets/WhatsApp_1.png"
                      className="sight_20_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleWhatsAppShare}
                      alt="Share on WhatsApp"
                    />

                  </div>
                </div>

           <div className="sight_20_para_wrapper">
                  <h2 className="sight_20_para_title">
                    For many years, Global Capability Centres were primarily seen as cost-efficient extensions of global organizations. Their role was focused on operations, technology support, shared services, and delivery.
                  </h2>
                 
                  
                </div>

              </div>

              <div className="sight_20_right">
                <div className="sight_20_ad_card">
                  <img src="/assets/bc_1.png" className="sight_20_ad_bg" />
                  <div className="sight_20_ad_overlay"></div>
                  <img src="/assets/bg_1.png" className="sight_20_ad_badge" />

                  <div className="sight_20_ad_content">
                    <h2>
                      Earn the Outstanding <br />
                      <span>Workplaces Certification</span>
                    </h2>
                    <ul>
                      <li>Attract Top Talent</li>
                      <li>Boost Employee Engagement</li>
                      <li>Drive Culture-Led Growth</li>
                    </ul>
                    <button
                      className="sight_20_ad_btn"
                      onClick={() => window.location.href = '/nominate'}
                    >
                      Get Certificate
                    </button>
                  </div>
                </div>
              </div>

            </div>

            
          </div>

          <div className="sight_20_section">
            <div className="sight_20_topics">

             

              <div className="sight_20_topic_item">
                <h3 className="sight_20_topic_heading">That story is changing</h3>
                <ul className="sight_20_topic_list">
                  <li>
                   In 2026, GCCs are increasingly becoming strategic capability centres. They are taking greater ownership of product engineering, advanced analytics, cybersecurity, artificial intelligence, digital transformation, and enterprise-wide innovation.
                  </li>
                  <li>
                    "How many employees can a GCC hire?"
                  </li>
                   <li>
                    "What strategic value can the GCC create for the global organization?"
                  </li>
                 
                </ul>
              </div>

              <div className="sight_20_topic_item">
                <h3 className="sight_20_topic_heading">The Shift Towards Value Creation</h3>
                <ul className="sight_20_topic_list">
                  <li>
                    Modern GCCs are being measured on outcomes.
                  </li>
                   <li>
                    Innovation. Speed to market. Product ownership. Intellectual property. Customer impact. Business growth.
                  </li>
                  <li>
                    This transformation is changing the workplace itself. Employees are no longer looking only for a stable job with a global brand. They want meaningful work, access to emerging technologies, opportunities to solve complex problems, and a clear path to leadership.
                  </li>
                  
                </ul>
              </div>

              <div className="sight_20_topic_item">
                <h3 className="sight_20_topic_heading">AI Is Accelerating the Transformation</h3>
                <ul className="sight_20_topic_list">
                  <li>
                   Artificial intelligence is rapidly changing how GCCs operate.
                  </li>
                  <li>
                  Routine and transactional work is increasingly being automated. At the same time, demand is growing for professionals who can combine AI knowledge with domain expertise, business understanding, creativity, and leadership.
                  </li>
                  <li>
                  The future GCC workforce will not simply compete with AI.
                  </li>
                   <li>
                  It will learn how to work with AI.
                  </li>
                  
                </ul>
              </div>

              <div className="sight_20_topic_item">
                <h3 className="sight_20_topic_heading">Talent Will Define the Next Generation of GCCs</h3>
                <ul className="sight_20_topic_list">
                  <li>
                   Technology can be acquired.
                  </li>
                  <li>
                  Talent cannot be easily replicated.
                  </li>
                  <li>
                  The most successful GCCs will be those that create workplaces where employees can continuously learn, experiment, contribute, and grow.
                  </li>
                   <li>
                  A strong workplace culture will become a business advantage.
                  </li>
                  
                </ul>
              </div>

              <div className="sight_20_topic_item">
                <h3 className="sight_20_topic_heading">Organizations must focus on:</h3>
                <ul className="sight_20_topic_list">
                  <li>Continuous learning and reskilling</li>
  <li>AI and digital capability building</li>
  <li>Career mobility</li>
  <li>Leadership development</li>
  <li>Employee wellbeing</li>
  <li>Meaningful employee experience</li>
  <li>Inclusion and belonging</li>
  <li>Recognition and purpose</li>
                  
                 
                </ul>
              </div>

              <div className="sight_20_topic_item">
                <h3 className="sight_20_topic_heading">The Outstanding Workplace Advantage</h3>
                <ul className="sight_20_topic_list">
                    <li>It is created when employees feel that they are learning, growing, trusted, valued, and connected to the organization's future.</li>
  <li>As GCCs become more strategic, workplace culture will become equally strategic.</li>
  <li>The next generation of GCCs will not be defined only by technology.</li>
  <li>They will be defined by their ability to build outstanding people experiences while creating global business impact.</li>
                 
                </ul>
              </div>
              <div className="sight_20_topic_item">
                <h3 className="sight_20_topic_heading">The GCC of the future is:</h3>
                <ul className="sight_20_topic_list">
     <li>AI-Powered.</li>
  <li>Skills-Driven.</li>
  <li>Innovation-Focused.</li>
  <li>Employee-Centric.</li>
  <li>Globally Connected.</li>
  <li>And the organizations that combine technology transformation with an outstanding workplace experience will be best positioned to lead the next era of global capability.</li>
                 
                </ul>
              </div>

              <div className="sight_20_topic_item">
                <h3 className="sight_20_topic_heading">Key takeaway: Don't wait until employees leave to ask them what went wrong. Listen while they are still part of the journey.</h3>
                
              </div>

              

            </div>
          </div>

        </div>
      </div>
    </>
  );
}

export default BlogPage;